import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["getStyleSheet"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mergeDeepRight } from 'ramda';

var hasOverrides = function hasOverrides(overrides, key) {
  return overrides && overrides[key];
};

var getOverridesSafe = function getOverridesSafe(overrides, key) {
  return function () {
    return hasOverrides(overrides, key) ? overrides[key].apply(overrides, arguments) : {};
  };
};

var getChildContext = function getChildContext(propTypes, __deprecatedMapping) {
  return function (_ref) {
    var getStyleSheet = _ref.getStyleSheet,
        overrides = _objectWithoutProperties(_ref, _excluded);

    var current = {};

    var _loop = function _loop() {
      var currentKey = _Object$keys[_i];

      current[currentKey] = function () {
        return mergeDeepRight(getOverridesSafe(getStyleSheet, currentKey).apply(void 0, arguments), getOverridesSafe(overrides, currentKey).apply(void 0, arguments));
      };
    };

    for (var _i = 0, _Object$keys = Object.keys(propTypes); _i < _Object$keys.length; _i++) {
      _loop();
    }

    var deprecated = {};

    var _loop2 = function _loop2() {
      var deprecatedKey = _Object$keys2[_i2];

      if (hasOverrides(overrides, deprecatedKey)) {
        var _process, _process$env;

        if ((_process = process) !== null && _process !== void 0 && (_process$env = _process.env) !== null && _process$env !== void 0 && _process$env.NODE_ENV && process.env.NODE_ENV !== 'production') {
          console.warn("BUBBLE-UI DEPRECATION WARNING: Deprecated stylesheet override ".concat(deprecatedKey, ". Please migrate to ").concat(__deprecatedMapping[deprecatedKey]));
        }

        deprecated[__deprecatedMapping[deprecatedKey]] = function () {
          return mergeDeepRight(getOverridesSafe(getStyleSheet, deprecatedKey).apply(void 0, arguments), getOverridesSafe(overrides, deprecatedKey).apply(void 0, arguments));
        };
      }
    };

    for (var _i2 = 0, _Object$keys2 = Object.keys(__deprecatedMapping); _i2 < _Object$keys2.length; _i2++) {
      _loop2();
    }

    return {
      getStyleSheet: _objectSpread(_objectSpread({}, current), deprecated)
    };
  };
};

export default getChildContext;
//# sourceMappingURL=getChildContext.js.map